import { levelExcude } from "../data/main";
import { stdObject } from "../data/types/stdObject";
import { versionsType } from "../data/types/versionsType";
import { endsWithNumber } from "./endsWithNumber";

export const filterSubsections = (subSections: stdObject) => {
  const cVersion = process.env.REACT_APP_VERSION as versionsType;
  const level = process.env.REACT_APP_VERSION_LEVEL as string;
  return Object.keys(subSections)
    .filter((e) => endsWithNumber(e) && subSections[e] > 0)
    .filter((e) => {
      const excludeLevel = levelExcude[cVersion]?.[level];
      return (
        !!excludeLevel &&
        e[0] in excludeLevel &&
        !excludeLevel[e[0]].includes(Number(e.slice(1)))
      );
    });
};
